// extracted by mini-css-extract-plugin
export var info = "styles-module--info--2Fl7E";
export var subHeaderTextWrapper = "styles-module--subHeaderTextWrapper--3z9OP";
export var forgotPasswordForm = "styles-module--forgotPasswordForm--1FTDt";
export var formHeader = "styles-module--formHeader--rEM4R";
export var formSubHeader = "styles-module--formSubHeader--2jxrC";
export var textError = "styles-module--textError--TmGpk";